import { supabase } from '@/lib/supabase';

export const ugcDealsService = {
  async list(userId) {
    const { data, error } = await supabase
      .from('ugc_deals')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async create(userId, payload) {
    const { data, error } = await supabase
      .from('ugc_deals')
      .insert({
        user_id: userId,
        brand: payload.brand,
        value: payload.value || 0,
        deliverables: payload.deliverables,
        stage: payload.stage || 'inbound',
        due_date: payload.due_date
      })
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async update(id, payload) {
    const { data, error } = await supabase
      .from('ugc_deals')
      .update({
        brand: payload.brand,
        value: payload.value,
        deliverables: payload.deliverables,
        stage: payload.stage,
        due_date: payload.due_date
      })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  }
};
